import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslationModule } from '@core/translation/translation.module';
import { AppDataShareBoatRef } from '@bcmServices/api-services/app-data-share.api-service';

@Component({
    selector: 'up2boat-id-boat-picker-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule, TranslationModule],
    template: `
        <h2 mat-dialog-title>{{ 'person.core.up2boatIdPickBoat' | translate:{}:'Boot auswählen' }}</h2>
        <div mat-dialog-content>
            <button *ngFor="let boat of data.boats"
                    mat-stroked-button
                    type="button"
                    style="display:block;width:100%;margin-bottom:8px;"
                    (click)="dialogRef.close(boat.id)">
                {{ boat.name || boat.licensePlate || boat.id }}
            </button>
        </div>
        <div mat-dialog-actions align="end">
            <button mat-button mat-dialog-close type="button">{{ 'common.cancel' | translate }}</button>
        </div>
    `
})
export class Up2boatIdBoatPickerDialogComponent {
    constructor(
        readonly dialogRef: MatDialogRef<Up2boatIdBoatPickerDialogComponent, number | null>,
        @Inject(MAT_DIALOG_DATA) readonly data: { boats: AppDataShareBoatRef[] }
    ) {}
}
